import React from 'react';

import Locale from 'data/locale';
import Store from 'store';

import './ImportPane.scss';
import { parseFile } from 'logic/binary';
import { OverlayContext } from 'ui/utils/OverlayManager';
import { stateAddProfile } from 'logic/stateReducers';
import { ErrorPopup } from 'ui/utils/Overlay';
import EditingContext from 'store/editingContext';

const _L = Locale("ui-import");

export default function ImportSection() {
  const dispatch = Store.useDispatch();
  const overlays = React.useContext(OverlayContext);
  const editingDispatch = EditingContext.useDispatch();
  const onChange = React.useCallback(e => {
    if (e.target.files.length > 0) {
      parseFile(e.target.files[0]).then(
        result => {
          dispatch.setState(state => stateAddProfile(state, result.profile, result.items));
          editingDispatch({type: "equipment"});
        },
        error => overlays.async(<ErrorPopup title={_L`Failed to parse file`} message={error.message}/>)
      );
    }
  }, [dispatch, overlays, editingDispatch]);

  return (
    <div className="d2p-SectionContent d2p-section-import">
      <div className="d2p-description">
        <p>Until there's a public API available (if ever), the only option we can provide is loading single player save files.</p>
        <p>Save files are located in your user folder, under <span style={{fontFamily: 'monospace', backgroundColor: '#111', padding: '0 3px'}}>Saved Games/Diablo II</span></p>
        <p>If the planner can't parse mods on an item, it will appear as 'Imported Item' and can not be edited, but will still function in the build.
        This should only happen for "cheated" items, if it happens with a legit in-game item, please report it on Discord!</p>
      </div>
      <div>
        <label className="d2p-file">
          <input style={{display: "none"}} type="file" onChange={onChange} accept=".d2s" multiple={false}/>
          Select a file, or drop it onto the page.
        </label>
      </div>
    </div>
  );
}
